import _ from 'lodash';
import { useFormContext } from 'react-hook-form';
import useRunSubmit from '../../hooks/useRunSubmit';
import Button from 'v3/common/components/Button';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
import AlgoverseDeploymentCostAlert from 'v3/common/components/Algoverse/DeploymentCostAlert';
import AlgoverseDeploymentCostModal from 'v3/common/components/Algoverse/DeploymentCostModal';
import useAlgoverseDeployment from 'v3/common/components/Algoverse/DeploymentCostModal/hook/useAlgoverseDeployment';

const propTypes = {};
const defaultProps = {};

const SubmitButton = () => {
  const { onSubmit, isLoading, shouldShowAlgoverseCostMessage, isPremiumOrProFeaturesEnabled, isLive } = useRunSubmit();
  const { handleSubmit } = useFormContext();
  const { openDeployFlow, isConfirmationOpen, closeModal, proceedToDeploy } = useAlgoverseDeployment();
  // const runConfig = useSelector((state) => state);
  const onError = (errors) => {
    const errorList = Object.values(errors);
    const firstError = _.find(errorList);

    if (!firstError?.ref?.name) return;

    const fieldName = firstError.ref.name;
    // eslint-disable-next-line no-undef
    const element = typeof document !== 'undefined' ? document.querySelector(`[name="${fieldName}"]`) : null;

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    } else if (firstError.ref.focus) {
      firstError.ref.focus();
    }
  };


  const renderButtonLable = () => {
    if (ApplicationDomainUtility.isAlgoverse && isLive) {
      return 'Deploy';
    } else if (ApplicationDomainUtility.isAlgoverse && !isLive) {
      return 'Run';
    } else {
      return 'Submit';
    }
  }

  return (
    <div className="runform-footer">
      {shouldShowAlgoverseCostMessage && (
        <AlgoverseDeploymentCostAlert isPremium={isPremiumOrProFeaturesEnabled} variant="alert" />
      )}
      <Button
        type="submit"
        isLoading={isLoading}
        className="btn btn-lg btn-success submit"
        onClick={handleSubmit(() => {
          if (shouldShowAlgoverseCostMessage) openDeployFlow(onSubmit)
          else onSubmit()
        }, onError)}
      >
        {renderButtonLable()}
      </Button>
      {isConfirmationOpen && (
        <AlgoverseDeploymentCostModal
          isPremium={isPremiumOrProFeaturesEnabled}
          isOpen={isConfirmationOpen}
          onClose={closeModal}
          onSave={() => proceedToDeploy(onSubmit)}
        />
      )}
    </div>
  );
};

SubmitButton.propTypes = propTypes;
SubmitButton.defaultProps = defaultProps;

export default SubmitButton;
